import { render, staticRenderFns } from "./HorizontalForm.vue?vue&type=template&id=3d153c54&scoped=true"
import script from "./HorizontalForm.vue?vue&type=script&lang=js"
export * from "./HorizontalForm.vue?vue&type=script&lang=js"
import style0 from "./HorizontalForm.vue?vue&type=style&index=0&id=3d153c54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d153c54",
  null
  
)

export default component.exports